import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PartyCustomerInfoComponent } from './party-customer-info.component';
import { DateFormatPipe } from '@tablesready/frontend-pipes';

const COMPONENTS = [
  PartyCustomerInfoComponent,
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    CommonModule,
    DateFormatPipe,
  ],
  exports: [...COMPONENTS],
})
export class PartyCustomerInfoModule { }
